import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const authService: AuthService = inject(AuthService);
  // const api: boolean = req.url.startsWith(environment.basePath);

  req = req.clone({
    withCredentials: true,
    setHeaders: { 
      Authorization: 'Bearer ' + authService.tokenValue
    }
  });

  return next(req);
}
